import React, { useEffect, useState } from 'react';
import recommend from '@algolia/recommend';
import { useInView } from 'react-intersection-observer';
import { ProjectSettings } from 'shared/types/ProjectSettings';
import SwiperCore, { FreeMode, Navigation, Pagination } from 'swiper';
import { lazyloadconfig } from '@/helpers/utils/brandButton';
import { useProjSettings } from '@/providers/projectSettings/hooks/useProjectSettings';
import AlgoliaRecommendProductsList from './algoliaRecommendProductsList';

SwiperCore.use([Pagination, Navigation, FreeMode]);

interface SeasonalSavingsProps {
  siteId?: string;
  setProductsHave: (haveProducts: boolean) => void;
}

let seasonalSavingItemsMemo: any = null;

const SeasonalSavings: React.FC<SeasonalSavingsProps> = ({ siteId, setProductsHave }) => {
  const [seasonalSavingItems, setSeasonalSavingItems] = useState<any>(undefined);
  const projectSettings: ProjectSettings = useProjSettings();
  const [inViewState, setInViewState] = useState<boolean>(false);

  useEffect(() => {
    setInViewState(true);
  }, []);

  const { ref, inView } = useInView({
    rootMargin: lazyloadconfig.rootMargin,
    triggerOnce: true,
  });

  useEffect(() => {
    if (!siteId || !projectSettings?.algoliaAppId || !projectSettings?.algoliaApiKey) {
      setProductsHave(false);
      return;
    }
    const recommendClient = recommend(projectSettings?.algoliaAppId, projectSettings?.algoliaApiKey);

    if (recommendClient && inView && !seasonalSavingItemsMemo) {
      const recommendationQueries: any = [
        {
          indexName: `products_${siteId}`,
          queryParameters: {
            filters: 'isInStock:true',
          },
        },
      ];
      recommendClient
        .getTrendingItems(recommendationQueries)
        .then((recommendations: any) => {
          if (recommendations?.results) {
            const seasonalSavingItems: any[] = [];
            recommendations?.results
              ?.filter((item: any, index: any) => {
                return recommendations?.results?.indexOf(item) === index;
              })
              ?.forEach((item: any) => {
                if (item?.hits && item?.hits.length > 0) {
                  seasonalSavingItems.push(...item.hits);
                }
              });
            setSeasonalSavingItems(seasonalSavingItems);
            setProductsHave(seasonalSavingItems?.length > 0);
            seasonalSavingItemsMemo = seasonalSavingItems;
          }
        })
        .catch((error) => {
          console.error('Error while fetching data:', error);
          setProductsHave(false);
          setSeasonalSavingItems(undefined);
        });
    } else {
      setProductsHave(seasonalSavingItemsMemo?.length > 0);
    }
  }, [projectSettings, siteId, inView]);

  return (
    <section className="seasonalSavings" ref={ref}>
      {(seasonalSavingItems || seasonalSavingItemsMemo) && (inView || !inViewState || seasonalSavingItemsMemo) && (
        <AlgoliaRecommendProductsList item={seasonalSavingItemsMemo ? seasonalSavingItemsMemo : seasonalSavingItems} />
      )}
    </section>
  );
};

export default SeasonalSavings;
